export default {"src":"/_next/static/media/h2o.108c0951.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};